import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";

const Kra = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="kra-page">
      <SEO
        title="Links to KRA Websites"
        description="Official links to KYC Registration Agencies (KRA) for verification and validation. Access NSEKRA, CAMSKRA, KARVYKRA, CVLKRA, and NDML KRA."
      />
      <section id="banner-slider" className="inn-banner-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner" role="listbox">
            <div
              className="carousel-item active"
              style={{
                backgroundImage: "url('/images/online-trading-bg.jpg')",
              }}
            >
              <canvas id="canvas" aria-hidden="true"></canvas>
              <div className="carousel-caption">
                <h1>Links To KRA</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="welcome-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2>Links To KRA</h2>
              <p>Here are the links to KRA Websites</p>
              <p>
                <a
                  href="https://www.nsekra.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  NSEKRA
                </a>
              </p>
              <p>
                <a
                  href="https://www.camskra.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CAMSKRA
                </a>
              </p>
              <p>
                <a
                  href="https://www.karvykra.com/index.aspx?ReturnUrl=%2f"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  KARVYKRA
                </a>
              </p>
              <p>
                <a
                  href="https://www.cvlkra.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CVLKRA
                </a>
              </p>
              <p>
                <a
                  href="https://kra.ndml.in/kra-web/jsps/menu/MainIndex.jsp"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  NDML KRA
                </a>
              </p>
              <p>
                <a
                  href="https://validate.cvlindia.com/CVLKRAVerification_V1/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CVL KRA KYC Validation Link
                </a>
              </p>
              <p>
                <a
                  href="https://kra.ndml.in/ClientInitiatedKYC-webApp/#/ClientinitiatedKYC"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  NDML KRA KYC Validation Link
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a href="#download" className="lm-btn">
                Download &amp; Explore More
              </a>
            </div>
            <div className="col-lg-6">
              <img
                src="/images/app-pic.jpg"
                className="img-fluid"
                alt="App Preview"
              />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default Kra;
